const isTouchable = () => window.matchMedia('(pointer: coarse)').matches;

export const getParser = UA => {
  return {
    UA,
    isTouchable
  };
};
//# sourceMappingURL=browser.js.map